export default __webpack_public_path__ + "static/media/footer.976b3460.jpg";